module.exports = __webpack_public_path__ + "static/media/bell-plus.4578d336.svg";